import {observer} from 'mobx-react';
import {Panel, FormLayout, Input} from 'shared/components';
import {LexicalEditor} from 'main/components';
import {t} from 'shared/core';
import schedulingLinkMergeField from './mergeFields';
import atsMergeFields from 'main/containers/recruiting/components/email_templates/mergeFields';

const InvitationEmail = observer(({uiState}) => {
  const {interviewSchedule, errors} = uiState;
  const {emailSubject, emailLexicalState} = interviewSchedule;

  return (
    <div>
      <Panel.Header title={t('recruiting.interview_schedules.edit.Invitation Email')}/>
      <FormLayout>
        <Input
          value={emailSubject}
          label='recruiting.interview_schedules.edit.invitation_email.Subject'
          onChange={e => interviewSchedule.merge({emailSubject: e.target.value})}
          errorMessage={errors.emailSubject}
        />
        <LexicalEditor
          label='recruiting.interview_schedules.edit.invitation_email.Message'
          placeholder='recruiting.interview_schedules.edit.invitation_email.Add email content'
          mergeFields={atsMergeFields}
          buttonMergeFields={[schedulingLinkMergeField]}
          initialEditorState={emailLexicalState}
          onChange={body => interviewSchedule.merge({emailRichText: body.html, emailLexicalState: body.state})}
          errorMessage={errors.emailRichText}
        />
      </FormLayout>
    </div>
  );
});

export default InvitationEmail;
